<template>
  <div
    class="container container-main py-2 md:py-[16px] bg-white z-10"
    :class="{
      'header-shadow': isOpenMenu,
    }"
  >
    <div class="flex items-center flex-col">
      <div class="flex w-full items-center min-[1440px]:gap-[10px]">
        <button
          v-if="!isOpenMenu"
          type="button"
          class="w-[32px] h-[32px] md:w-[44px] md:h-[44px] overflow-hidden min-[1440px]:hidden justify-center lg:mr-[18px] mr-[16px] min-w-[32px]"
          @click="$emit('toogle-menu')"
        >
          <icon-burger-menu class="text-[#052F41]" />
        </button>
        <button
          v-else
          type="button"
          class="flex items-center justify-center md:p-0 gap-2 uppercase w-[32px] h-[32px] md:w-[44px] md:h-[44px] text-primaryrounded-[5px] overflow-hidden min-[1440px]:hidden mr-[16px]"
          @click="$emit('toogle-menu')"
        >
          <icon-close class="text-[#052F41]" />
        </button>
        <div class="mx-auto min-[1440px]:mr-0 min-[1440px]:mx-0 min-[1440px]:shrink-0 max-[1280px]:ml-0">
          <figure class="flex items-center gap-1 min-[350px]:flex-wrap">
            <router-link :to="{ name: '/home' }" @click="$emit('close-mobile-menu')">
              <img loading="lazy" src="/img/logo/logo-kids.svg" alt="logo"
                class="w-[65px] md:w-[85px] min-[1440px]:w-[170px] min-[1440px]:block hidden" />
              <img loading="lazy" src="/img/logo/logo-kids-mobile.svg" alt="logo-mobile"
                class="logo-mobile min-[400px]:w-[250px] w-[121px] min-[1440px]:hidden block" />
            </router-link>
            <!-- hide doublicated logotypes
            <a href="https://kidscrafts.shop/" target="_blank" rel="noopener noreferrer">
              <img loading="lazy" src="/img/logo/logo-kids-store.svg" alt="store logo"
                class="w-[65px] md:w-[85px] xl:w-[110px] xl:block hidden" />
              <img loading="lazy" src="/img/logo/logo-kids-mobile-store.svg" alt="store logo mobile"
                class="logo-mobile min-[400px]:w-[190px] w-[121px] xl:hidden block" />
            </a> -->
          </figure>
        </div>
        <div class="flex md:hidden"></div>
        <div class="min-[1440px]:flex-col gap-4 min-[1440px]:w-full min-[1440px]:flex relative">
          <HeaderNavKids
            @open-partner-form="(type) => $emit('open-partner-form', type)"
          />
<!--          <div class="gap-6 hidden xl:flex mb-4 z-20">
          </div>-->
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import HeaderNavKids from "./header-nav/HeaderNavKids.vue";
// import HeaderCategoriesKids from "./header-categories/HeaderCategoriesKids.vue";
// import ProductSearchKids from "@/components/header/product-search-list/ProductSearchKids.vue";
import IconClose from "@/components/icons/IconClose.vue";
import IconBurgerMenu from "@/components/icons/IconBurgerMenu.vue";

defineProps({
  isOpenMenu: {
    type: Boolean,
    required: true,
  },
  isMobileSearch: {
    type: Boolean,
    required: true,
  },
});

defineEmits({
  "toogle-menu": null,
  "toogle-mobile-search": null,
  "close-mobile-menu": null,
  "open-partner-form": null,
  search: (value) => typeof value === "string",
});
</script>

<style lang="scss" scoped>
.logo-mobile {
  image-rendering: optimizeQuality;
}

.sticky {
  position: relative;
  @media (max-width: 768px) {
    @apply fixed;
  }
}

.header-shadow {
  @media (max-width: 768px) {
    @apply shadow-[0_4px_4px_rgba(0,0,0,0.05)];
  }
}
</style>
